import { render, staticRenderFns } from "./FormNewDocumentationFaqApi.vue?vue&type=template&id=50fb8bdf"
import script from "./FormNewDocumentationFaqApi.vue?vue&type=script&lang=js"
export * from "./FormNewDocumentationFaqApi.vue?vue&type=script&lang=js"
import style0 from "./FormNewDocumentationFaqApi.vue?vue&type=style&index=0&id=50fb8bdf&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50fb8bdf')) {
      api.createRecord('50fb8bdf', component.options)
    } else {
      api.reload('50fb8bdf', component.options)
    }
    module.hot.accept("./FormNewDocumentationFaqApi.vue?vue&type=template&id=50fb8bdf", function () {
      api.rerender('50fb8bdf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/NewServiceForm/components/FormNewDocumentationFaqApi.vue"
export default component.exports